import { CALLIGRAFIA, disableDropCoverType } from './coverHelper';

const TEMATIC = 'tematikus';

function isMultipleCover(placeholders, backgroundType) {
  const placeholderslength = Object.keys(placeholders).length;
  return backgroundType !== TEMATIC && placeholderslength > 1;
}

export function disabelImageDropRule(type, autofill, page, backgroundType) {
  const {
    isCover,
    isBabyPage,
    isFrontFlyLeaf,
    isBackFlyLeaf,
    placeholders,
  } = page;
  
  
  /* if( isCover && backgroundType === TEMATIC && type === CALLIGRAFIA ){
    return true
  } */
 
  if (((disableDropCoverType().includes(type) && !autofill))) {
    return false;
  }

  if (isBabyPage || isFrontFlyLeaf || isBackFlyLeaf) {
    return false;
  }


  if (isCover && (backgroundType === TEMATIC || isMultipleCover(placeholders, backgroundType))) {
    return true;
  }

  return false;
}


export function canDropImageToPlaceholder(backgroundType, type, page) {
  const {
    isCover,
    placeholders,
  } = page;

  if ((backgroundType === TEMATIC || isMultipleCover(placeholders, backgroundType)) && !type && (isCover)) {
    return false;
  }
  return true;
}

export function DropLimitReached(maximumPicturesReached, isChange, ifIsFlyLeaf, activePage) {
  if (
    ((maximumPicturesReached) && !isChange) ||
    (ifIsFlyLeaf && Object.keys(activePage.droppedImages).length === 1)
  ) {
    return true;
  }
  return false;
}

export function disableImageDropByType(pageType) {
  const disablePageType = [
    'isFrontFlyLeaf',
    'isBackFlyLeaf',
  ];

  return disablePageType.some(element => pageType[element]);
}



// WEBPACK FOOTER //
// ./src/helpers/dropHelper.js